import { render, staticRenderFns } from "./PermissionHelp.vue?vue&type=template&id=3a4523d6&scoped=true&"
import script from "./PermissionHelp.vue?vue&type=script&lang=ts&"
export * from "./PermissionHelp.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionHelp.vue?vue&type=style&index=0&id=3a4523d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4523d6",
  null
  
)

export default component.exports